import React, { useEffect, useState } from 'react'
import { Flex, Button, BoxProps, Box } from '@chakra-ui/core'
import { Dropdown, DropdownItem } from '../Dropdown'

export interface ProductUnitType {
  type: string
  interval: number
  format: string
}

export interface UnitSelectorProps {
  unitTypes: ProductUnitType[]
  defaultActive?: ProductUnitType
  onChange?: (unitType: ProductUnitType) => void
}

const MAX_UNIT_TYPES_IN_BUTTON = 3

const isNonDefaultActive = (unitType?: ProductUnitType) => unitType && unitType?.type && unitType.type !== 'default'

export const UnitSelector: React.FC<UnitSelectorProps> = ({ unitTypes = [], defaultActive, onChange }) => {
  const [active, setActive] = useState(defaultActive)

  useEffect(() => {
    setActive(defaultActive)
  }, [defaultActive])

  const activeStyles: BoxProps = {
    backgroundColor: 'transparent',
    borderColor: 'primary.500',
    boxShadow: 'none',
    color: 'primary.500',
  }

  const changeHandler = (unitType: ProductUnitType) => () => {
    setActive(unitType)
    onChange?.(unitType)
  }

  if (unitTypes.length > MAX_UNIT_TYPES_IN_BUTTON) {
    return (
      <Box mb="4" px=".6rem">
        <Dropdown
          items={unitTypes.map((unitType) => ({
            label: unitType.type,
            value: unitType,
          }))}
          selected={isNonDefaultActive(active) ? { label: active!.type, value: active } : undefined}
          onChange={(selection: DropdownItem) => {
            changeHandler(selection.value as ProductUnitType)()
          }}
        />
      </Box>
    )
  }

  return (
    <Flex justifyContent="space-between" mb="4">
      {unitTypes.map((unitType, index) => (
        <Button
          isActive={isNonDefaultActive(active) ? active?.type === unitType.type : index === 0}
          variant="outline"
          borderColor="gray.500"
          borderRadius=".4rem"
          backgroundColor="transparent"
          key={unitType.type}
          flex="1"
          mx="2"
          px="1.4rem"
          py="1rem"
          fontSize="1.4rem"
          fontWeight="normal"
          lineHeight="2"
          h="auto"
          cursor="pointer"
          _active={activeStyles}
          _hover={activeStyles}
          onClick={changeHandler(unitType)}
        >
          {unitType.type}
        </Button>
      ))}
    </Flex>
  )
}
